export enum ActionsTypeEnum {
    LogIntoFollowApp = 1, /*Ingreso a FollowApp desde enlace WhatsApp*/
    IdentificationFail = 2, /*No supera identificacion de cliente por patente/poliza*/
    AccountHolderSelectionFail = 3, /*No supera validacion en seleccion aleatoria de datos*/
    AccountHolderSelectionSuccess = 4, /*Supera validacion*/
    BlockWithConditions = 5 /*Bloqueo por condiciones*/
}
